/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TestResult interface.
 */
export function instanceOfTestResult(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('success' in value) || value['success'] === undefined)
        return false;
    return true;
}
export function TestResultFromJSON(json) {
    return TestResultFromJSONTyped(json, false);
}
export function TestResultFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'success': json['success'],
    };
}
export function TestResultToJSON(json) {
    return TestResultToJSONTyped(json, false);
}
export function TestResultToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'success': value['success'],
    };
}
